import * as React from 'react'
import styled from 'styled-components'

import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'

const STACK_3D_PATH = (
  <path
    d="m2 10 7.7138 3.8798c0.10495 0.0528 0.15742 0.0792 0.21246 0.0896 0.04875 0.0092 0.09876 0.0092 0.14756 0 0.055-0.0104 0.1075-0.0368 0.2124-0.0896l7.7138-3.8798m-16 4.0237 7.7138 3.8798c0.10495 0.0528 0.15742 0.0792 0.21246 0.0896 0.04875 0.0092 0.09876 0.0092 0.14756 0 0.055-0.0104 0.1075-0.0368 0.2124-0.0896l7.7138-3.8798m-16-8.0474 7.7138-3.8798c0.10495-0.05278 0.15742-0.07917 0.21246-0.08956 0.04875-0.0092 0.09876-0.0092 0.14756 0 0.055 0.01039 0.1075 0.03678 0.2124 0.08956l7.7138 3.8798-7.7138 3.8798c-0.1049 0.05279-0.1574 0.07918-0.2124 0.08957-0.0488 0.0092-0.09881 0.0092-0.14756 0-0.05504-0.01039-0.10751-0.03678-0.21246-0.08957l-7.7138-3.8798z"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
  />
)

const ID = 'stack-3d-stroke-glyph-icon'

export function Stack3dSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 20 20">
      {STACK_3D_PATH}
    </symbol>
  )
}

const Stack3dStandaloneContent = standalone(Stack3dSymbol, ID)

export const Stack3d = styled(function Stack3dComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="stack-3d">
      <Stack3dStandaloneContent />
    </Icon>
  )
})``

export const Stack3dLightweight = styled(function Stack3dComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="stack-3d-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
